import { PurchaseOrderPrintPage } from "@/features/purchase-order/pages/PurchaseOrderPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/purchase-order/$id/print")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseOrderPrintPage,
});
